import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    HttpInterceptor,
    HttpRequest,
    HttpEvent,
    HttpHandler,
    HttpErrorResponse,
} from '@angular/common/http';
import { StateService } from '@uirouter/angular';

@Injectable()
export class AuthHttpClientInterceptor implements HttpInterceptor {
    constructor(private state: StateService) {}
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        let token = localStorage.getItem('authenticationToken');
        const customRequest = !!token
            ? req.clone({
                  headers: req.headers.append(
                      'Authorization',
                      `Bearer ${token}`
                  ),
              })
            : req;
        return next.handle(customRequest).pipe(
            tap((response) => {
                if (
                    response instanceof HttpErrorResponse &&
                    (<HttpErrorResponse>response).status === 401
                ) {
                    this.state.go('home');
                }
            })
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/blocks/interceptor/auth.interceptor.ts